import { useQuery } from '@tanstack/react-query';
import API from '@/apiRequest';

/**
 * Hook to fetch all available order tags (bookmarks)
 */
export const useTags = () => {
  return useQuery({
    queryKey: ['tags'],
    queryFn: async () => {
      const cached = window.sessionStorage.getItem('cachedTags');
      if (cached) {
        return (JSON.parse(cached) || []).map(item => ({
          value: item.name,
          label: item.name,
        }));
      }
      const { data: tags } = await API.get('orders/tags');
      window.sessionStorage.setItem('cachedTags', JSON.stringify(tags));
      return (tags || []).map(item => ({
        value: item.name,
        label: item.name,
      }));
    },
    staleTime: Infinity,
    retry: 2,
  });
};
